import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectionStrategy, Component, OnInit, OnChanges, SimpleChanges, ViewChild, ViewEncapsulation, ElementRef, Input, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NotificationSearchService } from '../notification-search/notification-search.service';
import { AppUtils } from 'projects/dialog/src/app/shared/utilities/app-utils';
import { accountTableColumns, accountTableInit } from '../../constants';
import { NotificationAddRecipientsTemplateDialogComponent } from '../notification-add-recipients-template-dialog/notification-add-recipients-template-dialog.component';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { FilterOverlayDialogService } from '../filter-overlay-dialog/filter-overlay-dialog.service';
import { NotificationAuditTrailComponent } from '../notification-audit-trail/notification-audit-trail.component';
import { FileFormatDialogComponent } from '../file-format-dialog/file-format-dialog.component';


@Component({
  selector: 'dl-notification-accounts-table',
  templateUrl: './notification-accounts-table.component.html',
  styleUrls: ['./notification-accounts-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class NotificationAccountsTableComponent implements OnInit, OnChanges {

  @ViewChild(MatSort, { static: true }) public sort: MatSort;
  @ViewChild('exporter', { static: true }) exporter: ElementRef;
  @Input() notificationDetails: any;
  @Input() selectedRecepientColumns: any;
  @Input() contactDetails: any;
  @Input() notificationLabel: any;
  @Input() contactDataDetails: any;
  @Input() isSetCom: boolean = false;

  public displayedColumns: Array<string> = []
  public dataSource = new MatTableDataSource<any>();
  public selection = new SelectionModel(true, []);
  public selectedRow: any;
  public userPermission: any;
  public isAddRecipientDisabled = false;
  public isAfoBtnDisabled = false;
  public isAfoBtnExpanded = false;
  public filteredStatusList: any;
  public auditTrailDatafromAPI: any;
  public notificationId:any;

  public constructor(
    public router: Router, 
    public appUtils: AppUtils, 
    public qnsbnService: QnSbnService, 
    public filterOverlay: FilterOverlayDialogService,
    public notificationSearchService: NotificationSearchService,
    public changeDetectorRef: ChangeDetectorRef,
    public readonly oneSnackBar: OneSnackBarService, 
    public readonly dialog?: MatDialog, 
    public readonly resendDialog?: MatDialog,
  ) {}

  public ngOnInit(): void { 

    this.userPermission = this.qnsbnService.getUserData();

    if (this.selectedRecepientColumns > 0) {
      const recipientColumns = ['select'];
      let selectedColumns = this.selectedRecepientColumns.map(columnValue => columnValue.value);

      accountTableColumns.forEach(colObj => {
        if (selectedColumns.indexOf(colObj.value) !== -1) {
          recipientColumns.push(colObj.value);
        }
      });

      recipientColumns.push('Arrow');
      this.displayedColumns = recipientColumns;
    }
    
    this.sort.sort(({ id: 'Name', start: 'asc'}) as MatSortable);
    this.dataSource.sort = this.sort;
    this.dataSource.data = this.contactDetails;
    
    if (this.contactDetails.length > 0) {
      this.filteredStatusList = this.contactDetails.map(item => item.AccountStatus).filter((value, index, self) => self.indexOf(value) === index);
      this.filterOverlay.setStatusName(this.filteredStatusList);
    }

    this.notificationSearchService.searchData$.subscribe(searchValue => {
      this.dataSource.filter = searchValue;
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        return this.appUtils.getLowerCase(data.AccountId).includes(filter.toLowerCase()) 
        || this.appUtils.getLowerCase(data.AccountName).includes(filter.toLowerCase()) 
        || this.appUtils.getLowerCase(data.AccountDateSent).includes(filter.toLowerCase()) 
        || this.appUtils.getLowerCase(data.AccountDateDelivered).includes(filter.toLowerCase()) 
        || this.appUtils.getLowerCase(data.AccountDateRead).includes(filter.toLowerCase()) 
        || this.appUtils.getLowerCase(data.AccountFeedbackReceived).includes(filter.toLowerCase()) 
        || this.appUtils.getLowerCase(data.AccountStatus).includes(filter.toLowerCase()) 
        || this.appUtils.getLowerCase(data.DeliveryFailures).includes(filter.toLowerCase());
      };
      this.changeDetectorRef.detectChanges();
    });

    this.filterOverlay.filterData$.subscribe(filterValue => {
      this.filterSourceTable(filterValue);
    });

    this.isAddRecipientDisabled = this.notificationDetails.notificationData.Status === 'Complete' || this.notificationDetails.notificationData.Status === 'Completed';
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.userPermission = this.qnsbnService.getUserData();

    if(changes.selectedRecepientColumns){

      const currentChanges = changes.selectedRecepientColumns.currentValue;

      if (currentChanges.length > 0) {
        const recipientColumns = ['select'];
        let selectedColumns = currentChanges.map(columnValue => columnValue.value);

        accountTableColumns.forEach(colObj => {
          if (selectedColumns.indexOf(colObj.value) !== -1) {
            recipientColumns.push(colObj.value);
          }
        });

        recipientColumns.push('Arrow');
        this.displayedColumns = recipientColumns;
      }
    }

    this.dataSource.data = this.contactDetails;

    if(this.isAddRecipientDisabled){
      this.isSetCom = true;
    }

    this.changeDetectorRef.detectChanges();
  }

  public isAllSelected($event) {
    const numSelected = this.selection.selected.length;
    const numDisabled = this.dataSource.data.filter(row => row.disabled).length;
    const numRows = this.dataSource.data.length;
    return numSelected + numDisabled === numRows;
  }

  public masterToggle($event) {
    this.isAllSelected($event) ? this.selection.clear() : this.dataSource.data.forEach(row => (!row.disabled ? this.selection.select(row) : ''));
  }

  public handleChecked(row: any) {
    if (!row.disabled) {
      this.selection.toggle(row);
    }
  }

  public ndAddRecepients(): void {
    this.isAfoBtnDisabled = false;
    this.isAfoBtnExpanded = false;
    const tableColumnData = ['dragHandle', 'select', 'selectType', 'selectText', 'iconSets'];
    const templateDataList = [
      {
        dragHandle: '',
        select: '',
        selectType: 'Checkbox',
        selectText: 'Do you agree to it?',
        iconSets: 'delete-icon' // value should be 'yes-icon, more-icon, delete-icon'
      },
      {
        dragHandle: '',
        select: '',
        selectType: 'Question',
        selectText: 'How are you?',
        iconSets: 'delete-icon' // value should be 'yes-icon, more-icon, delete-icon'
      },
      {
        dragHandle: '',
        select: '',
        selectType: 'Checkbox',
        selectText: 'Are you ready?',
        iconSets: 'delete-icon' // value should be 'yes-icon, more-icon, delete-icon'
      }
    ];
    const dialogRef = this.dialog.open(NotificationAddRecipientsTemplateDialogComponent, {
      data: { 
        tableData: templateDataList,
        columnData: tableColumnData,
        notificationData: this.notificationDetails.notificationData,
        contactList: this.contactDataDetails
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!result.data) {
        return;
      }
      this.isAfoBtnDisabled = false;
      this.isAfoBtnExpanded = false;
      this.contactDetails = result.data;
      this.dataSource.data = result.accData;
      this.changeDetectorRef.detectChanges();
    });
  }

  public viewAuditTrail(): void {
    this.notificationId=this.notificationDetails.notificationData.NotificationId;

    this.qnsbnService.getNotificationAuditTrailList(this.notificationId).subscribe(
      res =>{
        this.auditTrailDatafromAPI=res;
        this.dialog.open(NotificationAuditTrailComponent,{
          data:{
            tableData: this.auditTrailDatafromAPI
          },
          disableClose: true,
          panelClass: 'AuditTrailPopUp'
        });
      },
      err =>{
        this.oneSnackBar.open('Failed to fetch Audit Trail Data', OneSnackBarType.ERROR, '', { duration: 5000 });
      }
    ); 
  }

  public gotoAccountDetailsPage(row) {
    let rowData = {
      customerData: row,
      isSetCom: this.isSetCom,
      notificationStatus:  this.isAddRecipientDisabled,
      notificationData: this.notificationDetails.notificationData
    };
    this.qnsbnService.getContactList(row.AccountNotificationId).subscribe(
      res =>{
        this.router.navigateByUrl('/account-details', { 
          state: { 
            customerDetails: rowData, 
            notificationDataObj: res.body 
          } 
        });
      },
      err =>{
        this.oneSnackBar.open('Failed to fetch Contact Data', OneSnackBarType.ERROR, '', { duration: 5000 });
      }
    );
  }

  public filterSourceTable(filterValue: any) {

    let datesent_start = this.appUtils.formatDateOnly(filterValue.dateSent_sdate);
    let datesent_end = this.appUtils.formatDateOnly(filterValue.dateSent_edate);
    let delivered_sdate = this.appUtils.formatDateOnly(filterValue.dateDelivered_sdate);
    let delivered_edate = this.appUtils.formatDateOnly(filterValue.dateDelivered_edate);
    let dateRead_sdate = this.appUtils.formatDateOnly(filterValue.dateRead_sdate);
    let dateRead_edate = this.appUtils.formatDateOnly(filterValue.dateRead_edate);
    let feedbackReceived_sdate = this.appUtils.formatDateOnly(filterValue.feedbackReceived_sdate);
    let feedbackReceived_edate = this.appUtils.formatDateOnly(filterValue.feedbackReceived_edate);

    if ( 
      filterValue.statusFilters.length < 1 
      && filterValue.dateSent_sdate == '' 
      && filterValue.dateDelivered_sdate == '' 
      && filterValue.dateRead_sdate 
      && filterValue.feedbackReceived_sdate
    ) {
      this.dataSource.data = this.contactDetails;
    } else {
      const statusFilterArray = this.contactDetails.filter(data => filterValue.statusFilters.includes(data.AccountStatus) || filterValue.statusFilters == '');
      const datedeliveredFilterArray = statusFilterArray.filter(data => (this.appUtils.formatDateOnly(data.AccountDateDelivered) >= delivered_sdate && this.appUtils.formatDateOnly(data.AccountDateDelivered) <= delivered_edate) || filterValue.dateDelivered_sdate == '');
      const datesentFilterArray = datedeliveredFilterArray.filter(data => (this.appUtils.formatDateOnly(data.AccountDateSent) >= datesent_start && this.appUtils.formatDateOnly(data.AccountDateSent) <= datesent_end) || filterValue.dateSent_edate == '');
      const datereadFilterArray = datesentFilterArray.filter(data => (this.appUtils.formatDateOnly(data.AccountDateRead) >= dateRead_sdate && this.appUtils.formatDateOnly(data.AccountDateRead) <= dateRead_edate) || filterValue.dateRead_sdate == '');
      const feedbackReceivedFilterArray = datereadFilterArray.filter(data => (this.appUtils.formatDateOnly(data.AccountFeedbackReceived) >= feedbackReceived_sdate && this.appUtils.formatDateOnly(data.AccountFeedbackReceived) <= feedbackReceived_edate) || filterValue.feedbackReceived_sdate == '');
      this.dataSource.data = feedbackReceivedFilterArray.filter(
        data => this.appUtils.getLowerCase(data.AccountDateRead) 
        || this.appUtils.getLowerCase(data.AccountFeedbackReceived) 
        || this.appUtils.getLowerCase(data.AccountStatus) 
        || this.appUtils.getLowerCase(data.AccountDateDelivered) 
        || this.appUtils.getLowerCase(data.AccountDateSent)
      );
    }
    this.changeDetectorRef.detectChanges();
  }

  public displayStatus(status) {
    const statusText = status ? status : 'Pending';
    return statusText;
  }

  public downloadReport(): void {
    const downloadReport = this.dialog.open(FileFormatDialogComponent, { disableClose: true });
    downloadReport.afterClosed().subscribe(
      (res) => {
        if (res === 'csv') {
          this.downloadCSV();
        }
        if (res === 'xlsx') {
          this.downloadXlsx();
        }
      },
      (error: HttpErrorResponse) => {
        this.oneSnackBar.open('Please try again later', OneSnackBarType.ERROR, '', { duration: 3000 });
      }
    );
  }

  public downloadCSV() {

    let csvData: any = {} ;
    let AccountNotificationId: any[] = [];
    let notificationId:any = this.dataSource.data[0].NotificationId;

    this.selection.selected.forEach(i => AccountNotificationId.push(i.AccountNotificationId));
    
    const fetchCsvApi = {
      NotificationId : notificationId,
      AccountNotificationIds: AccountNotificationId
    }
    
    const fetchCsvJson = JSON.stringify(fetchCsvApi);
    
    this.qnsbnService.fetchCSV(fetchCsvJson).subscribe(
      (data:any) => {
             
        csvData = data;
        const feedbackForms = Array.isArray(csvData.FeedbackForms) ? csvData.FeedbackForms[0] : {};
        const accounts = csvData.Accounts.map((row, index) => {
           const newrow : any = {};
           Object.keys(row).forEach(key=>{
            const feedbackValueMatch = key.match(/^Feedback(\d+)Value$/i);
            if(feedbackValueMatch){
                const feedbackIndex = feedbackValueMatch[1];
                if(feedbackForms[`Feedback${feedbackIndex}Label`] !== undefined){
                    newrow[`Feedback${feedbackIndex}Label`] = feedbackForms[`Feedback${feedbackIndex}Label`];
                }
                if(feedbackForms[`Feedback${feedbackIndex}Type`] !== undefined){
                    newrow[`Feedback${feedbackIndex}Type`] = feedbackForms[`Feedback${feedbackIndex}Type`];
                }
                if(feedbackForms[`Feedback${feedbackIndex}Mandatory`] !== undefined){
                    newrow[`Feedback${feedbackIndex}Mandatory`] = feedbackForms[`Feedback${feedbackIndex}Mandatory`];
                }
           }
            newrow[key] = row[key];
        })
        return newrow;
        });
        const headers = {
          ReconciliationStatsHeader: Object.keys(csvData.ReconciliationStats[0]),
          ReconciliationDataHeader: Object.keys(csvData.Contacts[0]),
          AccountSummaryHeader: Object.keys(accounts[0])
        } 
    
        
        const values = {
          ReconciliationStatsValue: csvData.ReconciliationStats.map((item) => Object.values(item).toString()),
          ReconciliationDataValue: csvData.Contacts.map(
            (item) =>{
              return Object.values(item).map(
                (val) => {
                  let strVal = val.toString();
                  if(strVal.includes(',')){
                    return `"${strVal}"`
                  }else{
                    return strVal
                  }
                }
              )
            }
          ),
          AccountSummaryValue: accounts.map(
            (item) =>{
              return Object.values(item).map(
                (val) => {
                  let strVal = val.toString();
                  if(strVal.includes(',')){
                    return `"${strVal}"`
                  }else{
                    return strVal
                  }
                }
              )
            }
          ),
        }
        
        this.appUtils.exportToCSV(values, this.notificationLabel, headers);

      },
      (error: HttpErrorResponse) => {
        this.qnsbnService.httpErrorHandler(error, 'Please try again later.');
      }
    );
  }

  public downloadXlsx() {

    let AccountNotificationId: any[] = [];
    let notificationId:any = this.dataSource.data[0].NotificationId;

    this.selection.selected.forEach(i => AccountNotificationId.push(i.AccountNotificationId));
    
    const fetchCsvApi = {
      NotificationId : notificationId,
      AccountNotificationIds: AccountNotificationId
    }
    
    const fetchCsvJson = JSON.stringify(fetchCsvApi);
    
    this.qnsbnService.fetchCSV(fetchCsvJson).subscribe(
      (data:any) => {
        const reportData = {
          AccountSummary: data.Accounts,
          ReconciliationStats: data.ReconciliationStats,
          ReconciliationData: data.Contacts,
          FeedbackData: data.FeedbackForms
        }
        this.appUtils.downloadExcel(reportData, this.notificationLabel);
      },
      (error: HttpErrorResponse) => {
        this.qnsbnService.httpErrorHandler(error, 'Please try again later.');
      }
    );
  }

}

